export default __webpack_public_path__ + "static/media/personal.4d6a5a0f.png";